var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-page", on: { scroll: _vm.handleScroll } },
    [
      _c("HomeHeader", { attrs: { scrollTop: _vm.scrollTop } }),
      _c("HomeTitle"),
      _c("HomeCondition"),
      _c("HomeProcess"),
      false ? _c("HomeMcn") : _vm._e(),
      _c("HomeFooter"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }